<template>
  <v-layout row align-center justify-space-between class="batch-item">
    <v-flex class="my-2" grow>
      <div class="font-weight-bold label my-1">Mixing Batch Number</div>
      <div class="font-weight-regular name my-1">{{batch.id}}</div>
    </v-flex>
    <v-flex shrink>
      <v-layout column align-end justify-center>
        <div class="font-weight-bold text-uppercase label my-1">Mixing Time</div>
        <div class="font-weight-regular primary--text value">{{formatDate(batch.dosing_at, true)}}</div>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>

import { mapGetters } from 'vuex'
import { formatDate } from '@/utils/date.js'

export default {
  name: 'BatchItem',
  props: ['batch'],
  computed: mapGetters({
    getFarm: 'getFarm'
  }),
  methods: {
    formatDate
  }
}
</script>

<style lang="scss" scoped>
.label{
  font-size: 11px;
}

.value{
  font-size: 16px;
}
</style>
